import styled from 'styled-components/macro';

export const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 0;
    padding-bottom: 16px !important;
    display: flex;
    flex-direction: column;
`;

export const Row = styled.div`
    margin: 0 -0.5em;
    transition: opacity 0.6s;
`;

export const FullRow = styled.div`
    width: 100%;
    padding: 0 8px;
`;

export const HalfRow = styled.div`
    width: 50%;
    padding: 0 0.5em;
    float: left;
`;

export const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-top: 0.75em;

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            ${props => (props.isSubmitting ? `text-indent: -99999px;` : '')};
            margin-left: 0.5em;

            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
            }
        }

        &.middleButton {
            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
                margin-right: 0.5em;
            }
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: 24%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;
            ${props => (props.isSubmitting ? `display: block` : '')};
        }
    }
`;

export const LegalInfoWrapper = styled.div`
    position: absolute;
    right: calc(100% + 1.2em);
    bottom: 16px;
    width: 45%;

    @media (max-width: 30em) {
        right: 0;
        width: 100%;
        bottom: 70px;
    }
`;

export const FormGroupWrapper = styled.div`
    @media (max-width: 30em) {
        flex: 1;
        display: flex;
        flex-direction: row;
        margin: 0 -0.5em;

        > div {
            flex: 1;
            display: flex;
            flex-direction: column;
            margin: 0 0.5em;
        }
    }

    ${props => props.horizontalLayout && 
        `display: flex; 
         align-items: center;
         max-height: fit-content`
    }
`;
